<template>
	<div>
		<loader :is-visible="isLoading"></loader>
		<div class="container">
			<h1>Pemilu & Periode</h1>
			<div class="container-form">
				<div class="section">
						<h2>Pemilu</h2>
						<div class="wrapper">
							<div class="input-data">
								<input type="text" required v-model="titlePemilu">
								<div class="underline"></div>
								<label>Title</label>
							</div>
							<p>*Notes <span style="color:red">Gunakan "###" untuk pemisah warna tulisan</span> ex: <span style="color:blue">Partai</span> ### <span style="color:red">Perindo</span></p>
						</div>
						<quill-editor
								class="mg-top1"
								v-model="descPemilu"
								:options="editorOption"
								@change="onEditorPemilu($event)"
						/>
						<div class="btn-heading">
							<p class="mg-top" v-if="errors.length">
								<b>Please correct the following error(s):</b>
								<ul>
										<li class="red" v-for="(error,index) in errors" :key="index">{{ error }}</li>
								</ul>
							</p>

							<div class="mg-top1">
								<button v-if="pemiluID" class="hov-del btn-add mg-right" @click="delData('pemilu_2019')">
									Delete Main
								</button>
								<button class="btn-add" @click="validationPemilu(pemiluID ? 'update' : 'add')">
									{{pemiluID? 'Update' : 'Add'}} Main
								</button>
							</div>
						</div>
				</div>

				<div class="section">
					<h2>Periode</h2>
					<div class="mg-top1">
						<div class="wrapper">
							<div class="input-data">
								<input type="text" required v-model="titleJokowi">
								<div class="underline"></div>
								<label>Title</label>
							</div>
							<p>*Notes <span style="color:red">Gunakan "###" untuk pemisah warna tulisan</span> ex: <span style="color:blue">Partai</span> ### <span style="color:red">Perindo</span></p>
						</div>
						<quill-editor
								class="mg-top1"
								v-model="descJokowi"
								:options="editorOption"
								@change="onEditorJokowi($event)"
						/>
					</div>
						<div class="btn-heading">
							<p class="mg-top" v-if="errors.length">
								<b>Please correct the following error(s):</b>
								<ul>
										<li class="red" v-for="(error,index) in errors" :key="index">{{ error }}</li>
								</ul>
							</p>

							<div class="mg-top1">
								<button v-if="jokowiID" class="hov-del btn-add mg-right" @click="delData('jokowi')">
									Delete
								</button>
								<button class="btn-add" @click="validationJokowi(jokowiID ? 'update' : 'add')">
									{{jokowiID? 'Update' : 'Add'}} Main
								</button>
							</div>
						</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import Loader from './../components/Loader.vue';
import alert from './../commons/alert.helper';
import axios from 'axios';
import { QuillDeltaToHtmlConverter } from 'quill-delta-to-html'

import auth from '@/service/auth.js'

export default {
	name: "TentangPeriode",
	data() {
		return {
			isLoading: false,
			pemiluID: '',
			titlePemilu: '',
			descPemilu: '',

			jokowiID: '',
			titleJokowi: '',
			descJokowi: '',

			errors: [],
			editorOption: {},
		}
	},
	methods: {
		convert(val, type) {
			let config = { inlineStyles: true }
			let converter = new QuillDeltaToHtmlConverter(val.ops, config)
			let html = converter.convert()
			if (type === 'pemilu') {
				this.descPemiluConvert = html
			} else if (type === 'periode') {
				this.descJokowiConvert = html
			}
		},
		onEditorPemilu({ quill}) {
			this.convert(quill.editor.delta, 'pemilu')
		},
		onEditorJokowi({ quill}) {
			this.convert(quill.editor.delta, 'periode')
		},
		validationPemilu(type) {
      this.errors = []

      if (!this.descPemilu) this.errors.push('* Title required')
      
      if (this.errors.length > 0) {
          return
      } else if (type === 'add') {
          this.addData('pemilu_2019')
      } else if (type === 'update') {
          this.updateData('pemilu_2019')
      }
    },
    validationJokowi(type) {
      this.errors = []

      if (!this.descJokowi) this.errors.push('* Description required')
      
      if (this.errors.length > 0) {
          return
      } else if (type === 'add') {
          this.addData('jokowi')
      } else if (type === 'update') {
          this.updateData('jokowi')
      }
    },
		async addData(type) {
			const res = await auth.checkAuth(this.$route.fullPath)
			if (res == false) {
				localStorage.clear()
				alert.failed('Unauthorized Token', () => this.$router.push('/login'))
			} else {
				try {
						this.isLoading = true
						const formData = new FormData()
						if (type === 'pemilu_2019') {
							formData.append('type', 'pemilu_2019')
							formData.append('title', this.titlePemilu)
							formData.append('description' , this.descPemiluConvert)
						} else if (type === 'jokowi') {
							formData.append('type', 'jokowi')
							formData.append('title', this.titleJokowi)
							formData.append('description', this.descJokowiConvert)
						}
					
						const response = await axios.post('/content/about', formData)
						this.isLoading = false

						console.log(response)
						if(response.status == 200) {
						    alert.success('Add data success', () => this.getData(type))
						}

				} catch (err) {
						console.log(err)
						this.isLoading = false
						alert.failed('Add data failed')
				}
			}
    },
		async updateData(type) {
			const res = await auth.checkAuth(this.$route.fullPath)
      if (res == false) {
          localStorage.clear()
          alert.failed('Unauthorized Token', () => this.$router.push('/login'))
      } else {
					try {
						this.isLoading = true
						const formData = new FormData()
						if (type === 'pemilu_2019') {
							formData.append('type', 'pemilu_2019')
							formData.append('title', this.titlePemilu)
							formData.append('description' , this.descPemiluConvert)
						} else if (type === 'jokowi') {
							formData.append('type', 'jokowi')
							formData.append('title', this.titleJokowi)
							formData.append('description', this.descJokowiConvert)
						}
					
						const response = await axios.patch(`/content/about/${type}`, formData)
						this.isLoading = false

						console.log(response)
						if(response.status == 200) {
								alert.success('Update data success', () => this.getData(type))
						}
				} catch (err) {
						console.log(err)
						alert.failed('Update data failed')
				}
			}
		},
		async getData(type) {
			this.isLoading = true
			try {
				const response = await axios.get('/content/about', { params: { type: type }})
				console.log(response)
        this.isLoading = false
				// this.descVisi = response.data.description
				if (type === 'pemilu_2019') {
					this.pemiluID = response.data.about_id
					this.titlePemilu = response.data.title
					this.descPemilu = response.data.description
				} else if (type === 'jokowi') {
					this.jokowiID = response.data.about_id
					this.titleJokowi = response.data.title
					this.descJokowi = response.data.description
				}
				
			} catch (error) {
				console.log(error)
        this.isLoading = false
			}
		},
		async delData(type) {
			let self = this
      alert.confirmation( async function () {
        self.isLoading = true
        try {
          const response = await axios.delete(`/content/about/${type}`)
          self.isLoading = false
          console.log(response)
          alert.success('Delete data success', () => self.resetData(type))
        } catch (error) {
          self.isLoading = false
          console.log(error)
          alert.failed('Delete data failed')
        }
      }, 'Are you sure to delete it?')
		},
		resetData(type) {
			if ( type == 'pemilu_2019') {
				this.pemiluID = ''
				this.titlePemilu = ''
				this.descPemilu = ''
			} else {
				this.jokowiID = ''
				this.titleJokowi = ''
				this.descJokowi = ''
			}
		}
	},
	computed: {
		editor() {
			return this.$refs.myQuillEditor.quill
		}
	},
	components: {
    Loader
  },
  async created () {
    const res = await auth.checkAuth(this.$route.fullPath)
    if (res == false) {
      localStorage.clear()
      this.$router.push('/login')  
    }
    this.getData('pemilu_2019')
    this.getData('jokowi')
  }
}
</script>